import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { Typography } from "@mui/material";

export const Loader = ({ message, height }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: height ?? "100vh",
      }}
    >
      <Typography sx={{ fontWeight: "bold" }}>
        {message ?? "Please Wait While Fetching Data..."}
      </Typography>
      <CircularProgress sx={{ mt: 1 }} size={26} />
    </Box>
  );
};
